/**
 * Canvas page chrome that must not affect item layout.
 *
 * Match Containd `canvasPageChrome.ts`: a layout `border` on the stage insets
 * the content box (CSS border-box), so item (0,0) and SVG (0,0) disagree.
 * Keep the stage size = frozen canvasWidth × canvasHeight and paint a 2px
 * outline with a negative-inset overlay.
 */
import type { CSSProperties } from 'react';

export const CANVAS_PAGE_BORDER_WIDTH = 2;

/** Stage coordinate box stays borderless so item (0,0) matches SVG (0,0). */
export const CANVAS_COORDINATE_VIEW_BORDER_WIDTH = 0;

export function canvasPageBorderOverlayStyle(borderColor: string): CSSProperties {
  return {
    position: 'absolute',
    top: -CANVAS_PAGE_BORDER_WIDTH,
    left: -CANVAS_PAGE_BORDER_WIDTH,
    right: -CANVAS_PAGE_BORDER_WIDTH,
    bottom: -CANVAS_PAGE_BORDER_WIDTH,
    borderWidth: CANVAS_PAGE_BORDER_WIDTH,
    borderStyle: 'solid',
    borderColor,
    pointerEvents: 'none',
    boxSizing: 'border-box',
  };
}

export function canvasPageStageBoxStyle(opts: {
  canvasWidth: number;
  canvasHeight: number;
  backgroundColor?: string;
  transform?: string;
}): CSSProperties {
  return {
    width: opts.canvasWidth,
    height: opts.canvasHeight,
    backgroundColor: opts.backgroundColor,
    boxSizing: 'border-box',
    borderWidth: CANVAS_COORDINATE_VIEW_BORDER_WIDTH,
    overflow: 'visible',
    transform: opts.transform,
    transformOrigin: '0 0',
  };
}
